// frontend/src/features/ups/ui/CompanyStatusBadge.js
import React from 'react';

/**
 * Company/admin passive status badge tones.
 *
 * This component owns visual badge styling only.
 * Domain mapping stays in the calling feature file.
 *
 * Example:
 * - ManageSites maps site.status -> active/neutral
 * - ManageInternalDrivers maps driver state -> active/requested/warning/banned/neutral
 * - UpsBlockedAssignmentsList maps blocked reason -> warning/danger/neutral
 *
 * Red/green/amber/blue are universal operational semantics,
 * not UPS-brand-specific theme colors.
 */
const toneClasses = {
  active: 'border-green-200 bg-green-50 text-green-700',
  requested: 'border-blue-200 bg-blue-50 text-blue-700',
  warning: 'border-amber-200 bg-amber-50 text-amber-700',
  danger: 'border-red-200 bg-red-50 text-red-700',
  banned: 'border-red-200 bg-red-50 text-red-700',

  // Neutral badge styling should remain theme-compatible.
  neutral: 'border-app-border bg-app-surface text-app-muted',
};

export default function CompanyStatusBadge({ tone = 'neutral', children, className = '' }) {
  // Unknown tones intentionally fall back to neutral instead of breaking rendering.
  const visualTone = toneClasses[tone] || toneClasses.neutral;

  return (
    <span
      className={[
        'inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold',
        visualTone,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
    </span>
  );
}

